import { useBreadcrumbs } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { Breadcrumbs as DesignSystemBreadcrumbs } from '@interxfi/design-system/components/breadcrumbs/breadcrumbs';
import styles from './breadcrumbs.module.scss';

export function Breadcrumbs() {
  const breadcrumbs = useBreadcrumbs();

  return <DesignSystemBreadcrumbs breadcrumbs={breadcrumbs} className={styles.breadcrumbs} />;
}
